<template>
    <div class="animated fadeIn master-form-page">
        <!-- Back Button -->
        <div class="mb-3">
            <button type="button" class="btn btn-back" @click="pindahKeMaster">
                <i class="fa fa-chevron-left mr-1"></i> Back
            </button>
        </div>

        <div class="master-form-card">
            <h4 class="form-page-title mb-4">Input Tipe Pinjaman</h4>

            <b-form @submit.prevent="openModalConfirm">
                <!-- DATA UMUM -->
                <div class="form-section-block">
                    <div class="form-section-header no-border">
                        <span class="section-accent-bar"></span>
                        <span class="section-label">DATA UMUM</span>
                    </div>

                    <b-row>
                        <!-- Kode Tipe Pinjaman -->
                        <b-col md="6" class="form-field-group mb-3">
                            <label class="field-label" for="inputKode">Kode Tipe Pinjaman <span class="text-danger">*</span></label>
                            <b-form-input 
                                id="inputKode"
                                v-model="input.kode" 
                                name="kode" 
                                placeholder="Contoh: ELK"
                                class="field-input w-100"
                                required
                            ></b-form-input>
                        </b-col>

                        <!-- Nama Tipe Pinjaman -->
                        <b-col md="6" class="form-field-group mb-3">
                            <label class="field-label" for="inputName">Nama Tipe Pinjaman <span class="text-danger">*</span></label>
                            <b-form-input 
                                id="inputName"
                                v-model="input.name" 
                                name="name" 
                                placeholder="Contoh: Elektronik"
                                class="field-input w-100"
                                required
                            ></b-form-input>
                        </b-col>
                    </b-row>

                    <!-- Keterangan -->
                    <b-row>
                        <b-col cols="12" class="form-field-group mb-4">
                            <label class="field-label" for="inputKeterangan">Keterangan</label>
                            <b-form-textarea
                                id="inputKeterangan"
                                v-model="input.keterangan"
                                name="keterangan"
                                placeholder="Contoh: Gadai barang elektronik seperti handphone, laptop, dan tablet."
                                rows="3"
                                max-rows="6"
                                class="field-textarea w-100"
                            ></b-form-textarea>
                        </b-col>
                    </b-row>
                </div>

                <!-- Actions Footer -->
                <div class="form-actions-footer d-flex align-items-center gap-2">
                    <button 
                        type="submit" 
                        name="tipePinjamanSubmitBtn" 
                        class="btn btn-submit mr-2" 
                        :disabled="isSubmitting"
                    >
                        <b-spinner small type="grow" v-if="isSubmitting" class="mr-1"></b-spinner>
                        {{ isSubmitting ? 'Memproses...' : 'Kirim' }}
                    </button>
                    <button 
                        type="button" 
                        class="btn btn-cancel" 
                        @click="pindahKeMaster"
                        :disabled="isSubmitting"
                    >
                        Batal
                    </button>
                </div>
            </b-form>
        </div>

        <!-- Modal Konfirmasi -->
        <ModalConfirm 
            id="modal-confirm-input" 
            title="Confirm Input Tipe Pinjaman" 
            :isSubmitting="isSubmitting" 
            desc="Apakah anda yakin untuk menginput tipe pinjaman ini?" 
            @submit="onSubmit" 
        />
    </div>
</template>

<script>
export default {
    name: 'tambah-tipe-pinjaman',
    data() {
        return {
            isSubmitting: false,
            input: {
                kode: '',
                name: '',
                keterangan: ''
            }
        }
    },
    methods: {
        openModalConfirm() {
            if (!this.input.kode || !this.input.name) {
                this.$helper.toastErr(this, 'Mohon lengkapi kolom yang wajib diisi!')
                return
            }
            this.$bvModal.show('modal-confirm-input')
        },

        onSubmit() {
            this.isSubmitting = true

            let payload = new FormData()
            payload.append('kode', this.input.kode.trim())
            payload.append('name', this.input.name.trim())
            payload.append('isActive', true)
            payload.append('status', true)

            if (this.input.keterangan && this.input.keterangan.trim() !== '') {
                payload.append('keterangan', this.input.keterangan.trim())
                payload.append('deskripsi', this.input.keterangan.trim())
            }

            this.$axios.post('tipe-pinjaman/', payload).then(response => {
                this.$helper.setFlash('Tipe pinjaman baru berhasil dibuat!')
                this.$bvModal.hide('modal-confirm-input')
                this.pindahKeMaster()
            }).catch(error => {
                // Fallback jika backend memerlukan endpoint tanpa trailing slash
                this.$axios.post('tipe-pinjaman', payload).then(response => {
                    this.$helper.setFlash('Tipe pinjaman baru berhasil dibuat!')
                    this.$bvModal.hide('modal-confirm-input')
                    this.pindahKeMaster()
                }).catch(err => {
                    console.error('Error create tipe pinjaman:', err)
                    this.$bvModal.hide('modal-confirm-input')
                    this.$helper.parseError(this, error || err)
                })
            }).finally(() => {
                this.isSubmitting = false
            })
        },

        pindahKeMaster() {
            this.$router.push('/master/tipe-pinjaman')
        }
    }
}
</script>

<style lang="scss" scoped>
.master-form-page {
    padding-bottom: 30px;
}

/* Back Button */
.btn-back {
    background-color: #ffffff;
    color: #334155;
    border: 1px solid #dcdfe6;
    border-radius: 8px;
    padding: 6px 16px;
    font-size: 13px;
    font-weight: 500;
    transition: all 0.2s ease;

    &:hover {
        background-color: #f8fafc;
        border-color: #cbd5e1;
        color: #0b3b36;
    }
}

/* Form Card */
.master-form-card {
    background: #ffffff;
    border-radius: 12px;
    padding: 24px 28px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.03);
    border: 1px solid #edf2f0;
}

.form-page-title {
    font-size: 20px;
    font-weight: 700;
    color: #0b3b36;
    letter-spacing: -0.2px;
}

/* Section Header */
.form-section-block {
    margin-bottom: 24px;
}

.form-section-header {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 20px;
}

.section-accent-bar {
    width: 3px;
    height: 16px;
    background-color: #d97706;
    border-radius: 2px;
}

.section-label {
    font-size: 11.5px;
    font-weight: 700;
    color: #0b3b36;
    letter-spacing: 0.8px;
    text-transform: uppercase;
}

/* Form Fields */
.field-label {
    font-size: 13px;
    font-weight: 600;
    color: #1e293b;
    margin-bottom: 6px;
    display: block;
}

.field-input,
.field-select {
    border-radius: 8px;
    border: 1px solid #dcdfe6;
    font-size: 13.5px;
    height: 40px;
    color: #334155;
    background-color: #ffffff;
    transition: all 0.2s ease;

    &:focus {
        border-color: #0b3b36;
        box-shadow: 0 0 0 2px rgba(11, 59, 54, 0.12);
    }

    &::placeholder {
        color: #94a3b8;
    }
}

.field-textarea {
    border-radius: 8px;
    border: 1px solid #dcdfe6;
    font-size: 13.5px;
    color: #334155;
    background-color: #ffffff;
    padding: 10px 12px;
    transition: all 0.2s ease;

    &:focus {
        border-color: #0b3b36;
        box-shadow: 0 0 0 2px rgba(11, 59, 54, 0.12);
    }

    &::placeholder {
        color: #94a3b8;
    }
}

/* Actions Footer */
.form-actions-footer {
    padding-top: 16px;
}

.btn-submit {
    background-color: #0b3b36;
    color: #ffffff;
    border: 1px solid #0b3b36;
    border-radius: 8px;
    padding: 8px 24px;
    font-size: 14px;
    font-weight: 600;
    transition: all 0.2s ease;

    &:hover:not(:disabled) {
        background-color: #082d29;
        border-color: #082d29;
        color: #ffffff;
    }

    &:disabled {
        opacity: 0.7;
        cursor: not-allowed;
    }
}

.btn-cancel {
    background-color: #ffffff;
    color: #475569;
    border: 1px solid #dcdfe6;
    border-radius: 8px;
    padding: 8px 20px;
    font-size: 14px;
    font-weight: 500;
    transition: all 0.2s ease;

    &:hover:not(:disabled) {
        background-color: #f8fafc;
        border-color: #cbd5e1;
        color: #1e293b;
    }
}

@media (max-width: 768px) {
    .master-form-card {
        padding: 16px;
    }
}
</style>